import axios from 'axios';

let config = {};
if (process.env.VUE_APP_API_HOST) {
    config.baseURL = process.env.VUE_APP_API_HOST;
    config.withCredentials = true;
    config.auth = {
        username: process.env.VUE_APP_BASE_AUTH_LOGIN,
        password: process.env.VUE_APP_BASE_AUTH_PASS,
    };
    config.headers = {
        spa: 'compare',
    };
}

const transport = axios.create(config);

export default transport;
